import { z } from 'zod'

import { ScoutConnectionImapFormSchema } from '../types/scoutConnectionImapFormSchema'

export const getScoutConnectionImapFormSchema = (): ScoutConnectionImapFormSchema =>
  z.object({
    email: z.string().email(),
    host: z.string().min(3),
    port: z.coerce.number().min(1).max(65535),
    password: z.string().min(3),
  })
